import type { PropsWithChildren } from 'react';

import { CMSSection } from '@/cms/CMSSection';
import { Container } from '@/components/Container';
import { useIsMdDown } from '@/hooks/useMedia';
import type { PlaceholderType } from '@/integrations/contentful';
import { generateDataTestId } from '@/lib/tests';

import { Features, Header } from './components';

import * as S from './KeyFeatures.styles';

export type KeyFeaturesProps = PropsWithChildren & {
  type: PlaceholderType;
  withSectionMargin: boolean | undefined;
};

export const KeyFeatures = ({
  children,
  type,
  withSectionMargin,
}: KeyFeaturesProps) => {
  const isMobileView = useIsMdDown();
  const withMargin =
    withSectionMargin !== undefined ? withSectionMargin : !isMobileView;
  return (
    <CMSSection
      data-test-id='KeyFeaturesSection'
      data-test-id-placeholder={type}
      withMargin={withMargin}
      {...generateDataTestId('section', type)}
    >
      <Container data-testid='KeyFeaturesWrapper'>{children}</Container>
    </CMSSection>
  );
};

KeyFeatures.Features = Features;
KeyFeatures.Header = Header;
KeyFeatures.RightContent = S.RightContent;

KeyFeatures.displayName = 'KeyFeatures';
